import { useQuery } from '@tanstack/react-query';
import { referralService } from '../referralService';
import { IGetReferrerResponse } from '../referralTypes';

export const useGetReferrer = () => {
  const { data, isLoading, error } = useQuery<IGetReferrerResponse, Error>({
    queryKey: ['referrer'],
    queryFn: () => referralService.getReferrer(),
  });

  return { data: data?.referrer || null, isLoading, error };
};
